import React from "react";
import { withBottombar } from "../../HOCs";
import DashboardMain  from "./dashboardNew";
class DashboardParent extends React.Component {
  render() {
    return <DashboardMain {...this?.props} />;
  }
}

const props = {
  top_bar: "top_nav_bar",
  bottom_bar: "bottom_nav_bar"
}

export default withBottombar(DashboardParent, props);
